import React from "react";
import {
  ProfileWrapper,
  ProfileInfo,
  ProfileTitle,
} from "./ProfileAddressHelpers";
import { useAppSelector } from "../../../hooks";
import { crmBasicProfileSelector } from "../../../redux/slices/Member/member";
import ProfileEditForm from "../ProfileEditForm/ProfileEditForm";

interface IProfileAddress {
  addressLine1?: string;
  streetAddress1?: string;
  city?: string;
  locality?: string;
  countryCode?: string;
  postalCode?: string;
  stateCode?: string;
  region?: string;
}

const ProfileAddress: React.FC = () => {
  const crmBasicProfile = useAppSelector(crmBasicProfileSelector);

  const [showEditForm, setShowEditForm] = React.useState(false);
  const address: IProfileAddress = crmBasicProfile?.address || {};
  const {
    addressLine1,
    streetAddress1,
    city,
    locality,
    postalCode,
    stateCode,
    region,
  } = address;

  const onEditProfile = () => {
    setShowEditForm(true);
  };
  return (
    <>
      {crmBasicProfile && (
        <>
          <ProfileTitle>My Profile</ProfileTitle>
          <ProfileWrapper>
            {showEditForm ? (
              <ProfileEditForm setShowEditForm={setShowEditForm} />
            ) : (
              <ProfileInfo
                firstName={crmBasicProfile.firstName}
                lastName={crmBasicProfile.lastName}
                email={crmBasicProfile.email}
                addressLine1={addressLine1 || streetAddress1}
                city={city || locality}
                postalCode={postalCode}
                stateCode={stateCode || region}
                onEditProfile={onEditProfile}
              ></ProfileInfo>
            )}
          </ProfileWrapper>
        </>
      )}
    </>
  );
};
export default ProfileAddress;
